import p_aloha from "../assets/textures/patterns/aloha_1200x1200px.webp";
import p_checker from "../assets/textures/patterns/checker_1200x1200px.webp";
import p_leopard from "../assets/textures/patterns/leopard_1200x3600px.webp";
import p_desert from "../assets/textures/patterns/desert_1200x3600px.webp";
import p_houndstooth from "../assets/textures/patterns/houndstooth_1200x1200px.webp";
import p_junglecamo from "../assets/textures/patterns/junglecamo_1200x3600px.webp";
import p_neonbluetechno from "../assets/textures/patterns/neonbluetechno_1200x3600px.webp";
import p_neyonyellowbolt from "../assets/textures/patterns/neonyellowbolt_1200x3600px.webp";
import p_null from "../assets/textures/patterns/null_1200x3600px.webp";
import p_serape from "../assets/textures/patterns/serape_1200x3600px.webp";
import p_undefined from "../assets/textures/patterns/undefined_1200x3600px.webp";
import p_normal from "../assets/textures/patterns/normal_1200x1200px.webp";
import p_whiteplain from "../assets/textures/patterns/whiteplain_1200x1200px.webp";

import r_aloha from "../assets/textures/patterns/r_aloha_1200x1200px.webp";
import r_checker from "../assets/textures/patterns/r_checker_1200x1200px.webp";
import r_leopard from "../assets/textures/patterns/r_leopard_1200x3600px.webp";
import r_desert from "../assets/textures/patterns/r_desert_1200x3600px.webp";
import r_houndstooth from "../assets/textures/patterns/r_houndstooth_1200x1200px.webp";
import r_junglecamo from "../assets/textures/patterns/r_junglecamo_1200x3600px.webp";
import r_neonbluetechno from "../assets/textures/patterns/r_neonbluetechno_1200x3600px.webp";
import r_neyonyellowbolt from "../assets/textures/patterns/r_neonyellowbolt_1200x3600px.webp";
import r_null from "../assets/textures/patterns/r_null_1200x3600px.webp";
import r_serape from "../assets/textures/patterns/r_serape_1200x3600px.webp";
import r_undefined from "../assets/textures/patterns/r_undefined_1200x3600px.webp";
import r_normal from "../assets/textures/patterns/r_normal_1200x1200px.webp";
import r_whiteplain from "../assets/textures/patterns/r_whiteplain_1200x1200px.webp";

import pt_aloha from "../assets/textures/patterns/thumb/aloha_thumb.webp";
import pt_checker from "../assets/textures/patterns/thumb/checker_thumb.webp";
import pt_leopard from "../assets/textures/patterns/thumb/leopard_thumb.webp";
import pt_desert from "../assets/textures/patterns/thumb/desert_thumb.webp";
import pt_houndstooth from "../assets/textures/patterns/thumb/houndstooth_thumb.webp";
import pt_junglecamo from "../assets/textures/patterns/thumb/junglecamo_thumb.webp";
import pt_neonbluetechno from "../assets/textures/patterns/thumb/neonbluetechno_thumb.webp";
import pt_neyonyellowbolt from "../assets/textures/patterns/thumb/neonyellowbolt_thumb.webp";
import pt_serape from "../assets/textures/patterns/thumb/serape_thumb.webp";
import pt_whiteplain from "../assets/textures/patterns/thumb/whiteplain_thumb.webp";
import swatch from "../assets/textures/seat-texture-small.webp";

import arctic_cat from "../assets/textures/logos/arcticcat.webp";
import can_am from "../assets/textures/logos/canam.webp";
import gasgas from "../assets/textures/logos/gasgas.webp";
import honda from "../assets/textures/logos/honda.webp";
import husqvarna from "../assets/textures/logos/husqvarna.webp";
import kawasaki from "../assets/textures/logos/kawasaki.webp";
import ktm from "../assets/textures/logos/ktm.webp";
import polaris from "../assets/textures/logos/polaris.webp";
import suzuki from "../assets/textures/logos/suzuki.webp";
import yamaha from "../assets/textures/logos/yamaha.webp";
import enjoyMfg from "../assets/textures/logos/enjoyMfg.webp";
import bolt from "../assets/textures/logos/bolt.webp";
import beta from "../assets/textures/logos/beta.webp";
import none from "../assets/textures/logos/none.webp";
import arctic_cat_r from "../assets/textures/logos/arcticcat-right.webp";
import can_am_r from "../assets/textures/logos/canam-right.webp";
import gasgas_r from "../assets/textures/logos/gasgas-right.webp";
import honda_r from "../assets/textures/logos/honda-right.webp";
import husqvarna_r from "../assets/textures/logos/husqvarna-right.webp";
import kawasaki_r from "../assets/textures/logos/kawasaki-right.webp";
import ktm_r from "../assets/textures/logos/ktm-right.webp";
import polaris_r from "../assets/textures/logos/polaris-right.webp";
import suzuki_r from "../assets/textures/logos/suzuki-right.webp";
import yamaha_r from "../assets/textures/logos/yamaha-right.webp";
import enjoyMfg_r from "../assets/textures/logos/enjoyMfg-right.webp";
import bolt_r from "../assets/textures/logos/bolt-right.webp";
import beta_r from "../assets/textures/logos/beta-right.webp";
import none_r from "../assets/textures/logos/none-right.webp";
import enjoyWebsiteLogo from "../assets/websiteLogos/enjoy-logo.webp";
import superliteWebsiteLogo from "../assets/websiteLogos/superlite-logo.webp";
// import arcticcat from "../assets/textures/logos/seat-texture-small.webp";
// import enjoyMfg from "../assets/textures/logos/seat-texture-small.webp";
// import yamaha from "../assets/textures/logos/seat-texture-small.webp";
// import polaris from "../assets/textures/logos/seat-texture-small.webp";
// import bolt from "../assets/textures/logos/seat-texture-small.webp";
// import none from "../assets/textures/logos/seat-texture-small.webp";

const patterns = {
  aloha: p_aloha,
  checker: p_checker,
  leopard: p_leopard,
  desert: p_desert,
  houndstooth: p_houndstooth,
  junglecamo: p_junglecamo,
  neonbluetechno: p_neonbluetechno,
  neonyellowbolt: p_neyonyellowbolt,
  null: p_null,
  serape: p_serape,
  undefined: p_undefined,
  normal: p_normal,
  whiteplain: p_whiteplain,
};

const ribPatterns = {
  aloha: r_aloha,
  checker: r_checker,
  leopard: r_leopard,
  desert: r_desert,
  houndstooth: r_houndstooth,
  junglecamo: r_junglecamo,
  neonbluetechno: r_neonbluetechno,
  neonyellowbolt: r_neyonyellowbolt,
  null: r_null,
  serape: r_serape,
  undefined: r_undefined,
  normal: r_normal,
  whiteplain: r_whiteplain,
};

const patternThumbs = {
  aloha: pt_aloha,
  checker: pt_checker,
  leopard: pt_leopard,
  desert: pt_desert,
  houndstooth: pt_houndstooth,
  junglecamo: pt_junglecamo,
  neonbluetechno: pt_neonbluetechno,
  neonyellowbolt: pt_neyonyellowbolt,
  serape: pt_serape,
  whiteplain: pt_whiteplain,
};

const logoImagesLeft = {
  arcticcat: arctic_cat,
  canam: can_am,
  gasgas: gasgas,
  honda: honda,
  husqvarna: husqvarna,
  kawasaki: kawasaki,
  ktm: ktm,
  polaris: polaris,
  suzuki: suzuki,
  yamaha: yamaha,
  enjoyMfg: enjoyMfg,
  bolt: bolt,
  beta: beta,
  none: none,
};

const logoImagesRight = {
  arcticcat: arctic_cat_r,
  canam: can_am_r,
  gasgas: gasgas_r,
  honda: honda_r,
  husqvarna: husqvarna_r,
  kawasaki: kawasaki_r,
  ktm: ktm_r,
  polaris: polaris_r,
  suzuki: suzuki_r,
  yamaha: yamaha_r,
  enjoyMfg: enjoyMfg_r,
  bolt: bolt_r,
  beta: beta_r,
  none: none_r,
};

const swatchTexture = {
  texture: swatch,
};

const websiteLogos = {
  enjoy: enjoyWebsiteLogo,
  superlite: superliteWebsiteLogo,
};

export {
  patterns,
  ribPatterns,
  patternThumbs,
  swatchTexture,
  logoImagesLeft,
  logoImagesRight,
  websiteLogos,
};
